"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var RowAvatar_1 = __importDefault(require("./components/RowAvatar"));
var utils_1 = require("./utils");
var CellPreContentFactory = function (_a) {
    var item = _a.item, cellConf = _a.cellConf;
    if (cellConf.avatar) {
        return ((0, jsx_runtime_1.jsx)(RowAvatar_1.default, __assign({ item: ('service' in item && item.service)
                || ('rechVendor' in item && item.rechVendor)
                || item }, cellConf.avatar)));
    }
    return null;
};
exports.default = (0, utils_1.typedMemo)(CellPreContentFactory);
